import {
  Grid,
  Theme,
  Typography,
  WithStyles,
  withStyles
} from '@material-ui/core'
import { TFunction } from 'i18next'
import { Fragment, useState } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { closeDialog, openDialog } from '../../../actions/dialogs'
import { navigate } from '../../../actions/routes'
import { deleteShowing } from '../../../actions/showings'
import { CloseDialog, Navigate, OpenDialog } from '../../../actions/types'
import DeleteFormButton from '../../../components/Buttons/DeleteFormButton'
import Container from '../../../components/Container'
import { selectApartmentById } from '../../../selectors/apartments'
import { selectContentIdFromPathname } from '../../../selectors/router'
import { DeleteShowingArgs } from '../../../services/showings'
import { Apartment } from '../../../types/apartments'
import {
  checkIfReservedShowing,
  Showing
  // ShowingType
} from '../../../types/showings'
import { StateInterface } from '../../../types/states'
import Dialog from '../../Dialog'
import ShowingCard from './ShowingCard'

const styles = ({ palette }: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column' as const
  },
  title: {
    'text-transform': 'uppercase',
    fontSize: '0.9rem !important',
    color: palette.grey[300]
  }
})

interface ShowingsListProps extends WithStyles {
  showings: Showing[]
  applications?: any
  t: TFunction
  useCase: 'confirmed' | 'waiting' | 'cancelled'
  /** showing type needs to be given when using create showing form data */
  // showingType?: ShowingType
  deleteShowing?: (args: DeleteShowingArgs) => void
}

interface StateProps {
  apartment?: Apartment
}

type DispatchProps = {
  openDialog: OpenDialog
  closeDialog: CloseDialog
  dispatchDeleteShowing: (args: DeleteShowingArgs) => void
  navigateToPath: Navigate
}

type ComponentProps = ShowingsListProps & StateProps & DispatchProps

const ShowingsList = ({
  dispatchDeleteShowing,
  openDialog,
  closeDialog,
  showings,
  classes,
  t,
  useCase,
  apartment,
  navigateToPath
}: ComponentProps) => {
  /** TODO: add check if any showings are included in useCase */
  //if (showings.length === 0) return <Fragment />;

  // const editShowing = (arg: string): void => {
  //   apartment &&
  //     navigateToPath(
  //       `/users/${apartment.userId}/apartments/${apartment.apartmentId}/showings/${arg}/edit`
  //     )
  // }

  //console.log(useCase, showings);
  const [deletingShowing, setDeletingShowing]: any = useState()

  const [currentShowing, setCurrentShowing]: any = useState()
  const handleDeleteShowing = () => {
    if (currentShowing) {
      setDeletingShowing(currentShowing)
      dispatchDeleteShowing({
        userId: currentShowing.userId,
        apartmentId: currentShowing.apartmentId,
        showingId: currentShowing.showingId
      })
      closeDialog(`confirmDeleteShowingDialog-${currentShowing?.showingId}`)
    }
  }

  const displayedShowings = showings
    ?.map(
      (showing: Showing) =>
        showing &&
        (useCase === 'confirmed'
          ? checkIfReservedShowing(showing)
          : !checkIfReservedShowing(showing)) && (
          <ShowingCard
            key={showing.showingId}
            showing={showing}
            isShowingDeleting={
              showing?.showingId === deletingShowing?.showingId
            }
            // handleOnClick={editShowing}
            t={t}
            useCase={'count'}
            openDialog={openDialog}
            setCurrentShowing={setCurrentShowing}
          />
        )
    )
    .filter((showing) => showing)
  return (
    <Fragment>
      {!!displayedShowings.length && (
        <Container className={classes.container}>
          <Grid>
            <Typography
              variant='subtitle1'
              gutterBottom
              className={classes.title}
            >
              {t(`showings.${useCase}`)}
            </Typography>
          </Grid>

          <div className={classes.container}>{displayedShowings}</div>
        </Container>
      )}
      <Dialog
        dialogId={`confirmDeleteShowingDialog-${currentShowing?.showingId}`}
        title={t('showings.createShowings.form.cancelShowing')}
        noOpenDialogButton
        Content={
          <Fragment>
            <Typography variant='h5' gutterBottom>
              {apartment &&
                apartment.information &&
                `${apartment.information.address}, ${apartment.information.postalCode} ${apartment.information.postalArea} `}
            </Typography>
            {currentShowing && (
              <ShowingCard
                key={currentShowing.showingId}
                showing={currentShowing}
                t={t}
                useCase={'empty'}
              />
            )}
            <DeleteFormButton
              fullWidth
              textColor='white'
              borderRadius='4px'
              variant='contained'
              submitting={false}
              label='showings.createShowings.form.cancelShowing'
              handleClick={handleDeleteShowing}
            />
          </Fragment>
        }
      />
    </Fragment>
  )
}

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectContentIdFromPathname(state)
  return {
    apartment: apartmentId ? selectApartmentById(apartmentId)(state) : undefined
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  openDialog: (id: string) => dispatch(openDialog(id)),
  closeDialog: (id: string) => dispatch(closeDialog(id)),
  dispatchDeleteShowing: (args: DeleteShowingArgs) =>
    dispatch(deleteShowing(args)),
  navigateToPath: (path: string) => dispatch(navigate(path))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ShowingsList))
